import React, { useEffect, useState, useContext } from "react";
import { getBatches2 } from "../api";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext"
import { deleteBatchConsolidado } from "../api"; // ajusta ruta si es distinta


const BatchList2 = ({ id_c }) => {
  const { t } = useContext(LanguageContext); // 👈 Usa el hook para traer traducciones
  const [data, setData] = useState(null);

  const [filterBatch, setFilterBatch] = useState("");
  const [filterMachine, setFilterMachine] = useState("");
  const [filterProduct, setFilterProduct] = useState("");
  const [filterDateFrom, setFilterDateFrom] = useState("");
  const [filterDateTo, setFilterDateTo] = useState("");

  const navigate = useNavigate(); // Hook para navegación




  useEffect(() => {
    const fetchData = async () => {
      const result = await getBatches2(id_c);
      console.log("📦 Batches recibidos:", result); // 👈 aquí
      setData(result);
    };
    fetchData();
  }, [id_c]);

  if (!data) return <p>{t('MList1')}</p>;



  // 👇 Aquí colocas este bloque justo después del `if (!data) return`
  const filterBatchClean = filterBatch.trim().toLowerCase();
  const filterMachineClean = filterMachine.trim().toLowerCase();
  const filterProductClean = filterProduct.trim().toLowerCase();

  const filteredData = data.batches.filter((batch) => {
    const batchIdStr = batch.id_batch?.toString().toLowerCase() ?? "";
    const codMaqStr = batch.cod_maq?.toLowerCase() ?? "";
    const idProdStr = batch.id_prod?.toString().toLowerCase() ?? "";
    const batchDate = batch.date_begin
      ? new Date(batch.date_begin).toISOString().split("T")[0]
      : "";

    if (filterDateFrom && batchDate < filterDateFrom) return false;
    if (filterDateTo   && batchDate > filterDateTo)   return false;

    return (
      batchIdStr.startsWith(filterBatchClean) &&
      codMaqStr.startsWith(filterMachineClean) &&
      idProdStr.startsWith(filterProductClean)
    );
  });


  console.log("🧪 Input actual:", filterProductClean);
  console.log("🔍 Resultados filtrados:");
  filteredData.forEach(batch => {
    console.log(batch.id_prod);
  });

  return (
    <div className="box1">
      <div className="box9">
        <button className="button7" onClick={() => navigate("/new_batch")}>
          {t('batchList11')}
        </button>

        {/* Filtro de fechas */}
        <div style={{ clear: "both", width: "100%", display: "flex", justifyContent: "center", padding: "6px 0" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span className="text3" style={{ whiteSpace: "nowrap" }}>{t("atr_dateFrom")}</span>
            <input
              type="date"
              value={filterDateFrom}
              onChange={(e) => setFilterDateFrom(e.target.value)}
            />
            <span className="text3" style={{ whiteSpace: "nowrap" }}>{t("atr_dateTo")}</span>
            <input
              type="date"
              value={filterDateTo}
              onChange={(e) => setFilterDateTo(e.target.value)}
            />
            {(filterDateFrom || filterDateTo) && (
              <button
                className="button8"
                onClick={() => { setFilterDateFrom(""); setFilterDateTo(""); }}
                style={{ whiteSpace: "nowrap", width: "auto" }}
              >
                ✕ {t("atr_all")}
              </button>
            )}
          </div>
        </div>

        {/* Filtros de texto */}
        <div className="table5">
          <input
            type="text"
            placeholder="🔎 Filtrar por lote"
            value={filterBatch}
            onChange={(e) => setFilterBatch(e.target.value)}
            style={{ width: "30%", float: "left" }}
          />
          <input
            type="text"
            placeholder="🔎 Filtrar por máquina"
            value={filterMachine}
            onChange={(e) => setFilterMachine(e.target.value)}
            style={{ width: "30%", float: "left" }}
          />
          <input
            type="text"
            placeholder="🔎 Filtrar por producto"
            value={filterProduct}
            onChange={(e) => setFilterProduct(e.target.value)}
            style={{ width: "30%", float: "left" }}
          />
        </div>


        <table className="table5">
          <thead>
            <tr>
              <th>{t("batchList7")}</th>
              <th>{t("shifts1")}</th>
              <th>{t("operator1")}</th>
              <th>{t("batchList12")}</th>
              <th>{t("batchList2")}</th>
              <th>{t("batchList3")}</th>
              {/*<th>{t("batchList27")}</th> */}
              <th>{t("batchList8")}</th>
              <th>{t("batchList10")}</th>
              <th colSpan={2}>{t("actType6")}</th>
            </tr>
          </thead>
          <tbody>

            {filteredData.map((batch, index) => (
              <tr key={`${batch.id_batch}-${batch.id_prod}-${index}`}>

                <td>{new Date(batch.date_begin).toISOString().split("T")[0]}</td>
                <td>{batch.id_shift}</td>
                <td>{batch.id_operator}</td>
                <td>{batch.id_batch}</td>
                <td>{batch.cod_maq}</td>
                <td>{batch.id_prod}</td>
{/*                <td>{batch.model}</td> */}
                <td>{batch.time_begin?.slice(0, 5)}</td>
                <td>{batch.time_end?.slice(0, 5)}</td>
                <td>

                  <button

                    className="button"
                    onClick={() => navigate(`/edit_batch/${batch.id}`)} // usa el id del registro en batches_consolidado
                  >
                    {t("MList7")} {/*edit */}


                  </button>
                </td>
                <td>
                  <button
                    className="buttonDel"
                    onClick={async () => {
                      const confirm = window.confirm("¿Estás seguro de eliminar este registro?");
                      if (!confirm) return;

                      try {
                        await deleteBatchConsolidado(batch.id); // usa el ID único del registro
                        const result = await getBatches2(id_c);  // recarga la data
                        setData(result);
                      } catch (error) {
                        console.error("❌ Error al eliminar:", error);
                        alert("Error al eliminar el registro");
                      }
                    }}
                  >
                    {t("general1")}
                  </button>
                </td>

              </tr>
            ))}
          </tbody>
        </table>

      </div>
    </div>
  );
};

export default BatchList2;